import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-bar-chart-inactive-pathology-duration-from-user',
  templateUrl: './bar-chart-inactive-pathology-duration-from-user.component.html',
  styleUrls: ['./bar-chart-inactive-pathology-duration-from-user.component.css']
})
export class BarChartInactivePathologyDurationFromUserComponent implements OnInit {

     
      numberFormPathologyDuration = new FormGroup({
        from: new FormControl(''),
        to: new FormControl(''),
      });
      
              // per inizializzazione
              getAuthState: Observable<any>;
              getDoctorState: Observable<any>;
              isAuthenticated: boolean;
              user = null;
              errorMessage = null;
              subscription1: Subscription;
              subscription5: Subscription;
              subscription6: Subscription;
              title = "Durata patologia";
              destination = 'inactive';
    
              // elementi che servono per il bar-chart
              canvas: any;
              ctx: any;
              myChartInactivePatients: Chart;
        
              // ******************************************************************************************************************
              // seguenti righe: inizializzazione dei pazienti 
              // ******************************************************************************************************************
              inactiveGlobalFasciaA = 0;      
              activeGlobalFasciaA = 0;
              GlobalPatientsFasciaA = 0;    
        
              inactiveGlobalPatientsArray = [];
              activeGlobalPatientsArray = [];
              inactivePatientsGlobal = [];
              // ******************************************************************************************************************
              // bar chart dei pazienti 
              // ******************************************************************************************************************
              public barChartLabelsGlobalInactive = ['Fascia'];
              public barChartTypeGlobalInactive = 'horizontalBar';
              public barChartLegendGlobalInactive = true;
              public barChartDataGlobalInactive = [
                {
                  data: this.activeGlobalPatientsArray, label: 'Attivo', backgroundColor: ['teal'],
                  hoverBackgroundColor: ['#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
                },
                {
                  data: this.inactiveGlobalPatientsArray, label: 'Inattivo', backgroundColor: ['orangered'],
                  hoverBackgroundColor: ['#cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
                }];
              
        
        
              // constructor
              constructor(private store: Store<AppState>,
                          private doctorService: DoctorService,
                          private snackBar: MatSnackBar) {
                this.getAuthState = this.store.select(selectAuthState);
                this.getDoctorState = this.store.select(selectDoctorState);
              }
              // ******************************************************************************************************************
              // metodo all'inizio
              ngOnInit(): void {
                this.subscription6 = this.getAuthState.subscribe((state) => {
                  this.isAuthenticated = state.isAuthenticated;
                  this.user = JSON.parse(localStorage.getItem('user'));
                  this.errorMessage = state.errorMessage;
                });
              }
  
              ngOnDestroy(): void {
                this.subscription1.unsubscribe();
                this.subscription5.unsubscribe();
                this.subscription6.unsubscribe();
              }
  
              clearData() {
                this.inactiveGlobalFasciaA = 0;      
                  this.activeGlobalFasciaA = 0;
                  this.GlobalPatientsFasciaA = 0;    
        
                  this.inactiveGlobalPatientsArray = [];
                  this.activeGlobalPatientsArray = [];
                  this.inactivePatientsGlobal = [];
  
                  if(this.myChartInactivePatients!=null) {
                  this.myChartInactivePatients.clear();
                  this.myChartInactivePatients.destroy(); }
                  this.canvas =null;
                  this.ctx = null;
                this.barChartDataGlobalInactive=[
                  {
                    data: this.activeGlobalPatientsArray, label: 'Accesso effettuato', backgroundColor: ['teal'],
                    hoverBackgroundColor: ['#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
                  },
                  {
                    data: this.inactiveGlobalPatientsArray, label: 'Accesso non effettuato', backgroundColor: ['orangered'],
                    hoverBackgroundColor: ['#cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
                  }];
              }
              // ******************************************************************************************************************
              // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
              // e in standard e poi tutti
              // i pazienti in ogni categoria per poter calcolare gli attivi
              // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
  
              onSubmitPathologyDurationForm() {
                this.clearData(); 
                this.retrieveGlobalInactiveFromUtente(this.numberFormPathologyDuration.get('from').value,this.numberFormPathologyDuration.get('to').value);
              }
              
              retrieveGlobalInactiveFromUtente(from,to) {
                this.subscription1 = this.doctorService.getInactivePathologyDurationBracketsNumber(from,to).subscribe(npatients => {
                  this.inactiveGlobalFasciaA = parseInt(npatients.toString());
                  this.inactiveGlobalPatientsArray.push(this.inactiveGlobalFasciaA); // riempio il vettore del bar chart con standard
                  this.retrieveGlobalPathologyDuration(from,to);
      
                }, error => {
                  if (error.status === 500) {
                    localStorage.setItem('expirationTime', '0');
                    console.log('SESSIONE SCADUTA');
                    location.reload();
                  }
                });
              }
    
              retrieveGlobalPathologyDuration(from,to) {
                this.subscription5 = this.doctorService.getGlobalPathologyDurationFromUserLoginExistsNumber(from,to).subscribe(num => {
                  this.GlobalPatientsFasciaA = num[0];
                  this.activeGlobalFasciaA = this.GlobalPatientsFasciaA - this.inactiveGlobalFasciaA;
                  this.activeGlobalPatientsArray.push(this.activeGlobalFasciaA); // riempio il vettore del bar chart con standard           
                  console.log(this.GlobalPatientsFasciaA);
                  console.log(this.activeGlobalFasciaA);
                  console.log(this.inactiveGlobalFasciaA);
                  console.log(this.barChartDataGlobalInactive);
                  this.canvasSetting();
                }, error => {
                  if (error.status === 500) {
                    localStorage.setItem('expirationTime', '0');
                    console.log('SESSIONE SCADUTA');
                    location.reload();
                  }
                });
              }
             
              canvasSetting() {
  
                  this.canvas = document.getElementById('myChartInactivePathologyDurationFromUser') as HTMLCanvasElement;
                  this.ctx = this.canvas.getContext('2d');
                  this.myChartInactivePatients = new Chart(this.ctx, {
                    type: this.barChartTypeGlobalInactive,
                    data: {
                      labels: this.barChartLabelsGlobalInactive,
                      datasets: this.barChartDataGlobalInactive,
                    },
                    options: {
                      maintainAspectRatio: true,
                      responsive: true,
        
                      scales: {
                        xAxes: [{
                          display: true,
                          stacked: false,
                          ticks: {
                            fontSize: 12,
                            fontStyle: 'bold',
                            fontFamily: 'Helvetica',
                            fontColor: '#006192'
                          }
                        }],
                        yAxes: [{
                          display: true,
                          stacked: false,
                          ticks: {
                            fontSize: 12,
                            fontStyle: 'bold',
                            fontFamily: 'Helvetica',
                            fontColor: '#006192'
                          }
                        }],
                      },
                      legend: {
                       
                        display: true,
                        position: 'top',
                        labels: {
                          usePointStyle: true,
                          fontColor: '#006192',
                          fontSize: 18,
                          fontFamily: 'Helvetica',
                        }
                      },
                      tooltips: {
                        // content: '{pathology}: {number}',
                        backgroundColor: '#1c1c1c',
                        bodyFontSize: 18,
                        titleFontSize: 18,
                        cornerRadius: 5,
                        caretPadding: 10
                      },
                      title: {
                        display: true,
                        text: "N° di utenti attivi/inattivi",
                        fontColor: '#006192',
                        fontSize: 20,
                        fontFamily: 'Helvetica',
                      },
                      hover: {
                        mode: 'nearest',
                        intersect: true
                      }
                    }
                  });
                  } // dopo aver ottenuto tutti i dati creo il bar chart
              
            }
            
  